import React, { useState, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import CTTable from "./CTTable";

const CTSelectTable = ({
  data = [],
  columns = [],
  getRowId = (row) => row.ID,
  checkField = "check",
  onSelectionChange,
  rowClassName = "bg-blue-100",
  stripe = true,
  hover = true,
  ...rest
}) => {
  // Alterna select/deselect all
  const toggleAll = useCallback(() => {
    const allChecked = data.every((row) => !!row[checkField]);
    const newData = data.map((row) => ({
      ...row,
      [checkField]: allChecked ? 0 : 1,
    }));
    onSelectionChange?.(newData);
  }, [data, checkField, onSelectionChange]);

 const toggleRow = useCallback(
  (row) => {
    const rowId = getRowId(row); // o usa getRowId(row) si lo pasas como prop
   
    const newData = data.map((r) =>
      getRowId(r) === rowId ? { ...r, [checkField]: r[checkField] ? 0 : 1 } : r
    );
   
    onSelectionChange?.(newData);
  },
  [data, checkField, getRowId, onSelectionChange]
);
  // Añade columna de checkboxes sticky a la izquierda
  const selectableColumns = useMemo(() => {
    return [
      {
        key: "__select",
        accessor: checkField, // 👈 debe coincidir con el campo real en row
        type: "check", // 👈 importante para renderCellContent
        header: (
          <input
            type="checkbox"
            checked={data.length > 0 && data.every((row) => !!row[checkField])}
            ref={(el) => {
              if (el) {
                const someChecked =
                  data.some((row) => !!row[checkField]) &&
                  !data.every((row) => !!row[checkField]);
                el.indeterminate = someChecked;
              }
            }}
            onChange={toggleAll}
          />
        ),
        cell: (row) => (
          <input
            type="checkbox"
            checked={!!row[checkField]}
            onChange={() => toggleRow(row)}
          />
        ),
        LLARGEDIT: 2,
        className: "sticky left-0 bg-white z-20",
      },
      ...columns,
    ];
  }, [columns, data, checkField, toggleAll, toggleRow]);

  // Función para aplicar clases de fila (selección, striped, hover)
  const getRowClass = (row, index) => {
    let cls = "";
    if (row[checkField]) cls += ` ${rowClassName}`;
    if (stripe && index % 2 === 1) cls += " bg-gray-50 dark:bg-gray-700";
    if (hover) cls += " hover:bg-blue-50 dark:hover:bg-blue-700";
    return cls.trim();
  };

  const tableWrapperClass =
    "overflow-auto max-h-[400px] border border-gray-300 dark:border-gray-700";

  return (
    <div className={tableWrapperClass}>
      <CTTable
        data={data}
        columns={selectableColumns}
        getRowClass={getRowClass}
        getRowId={(row) =>getRowId(row)}
        toggleRow={(row) =>toggleRow(row)} // 👈 necesario
        hoverEffect={false} // usamos hover por CSS
        {...rest}
      />
    </div>
  );
};

CTSelectTable.propTypes = {
  ...CTTable.propTypes,
  checkField: PropTypes.string,
  onSelectionChange: PropTypes.func,
  rowClassName: PropTypes.string,
  stripe: PropTypes.bool,
  hover: PropTypes.bool,
};

CTSelectTable.defaultProps = {
  checkField: "check",
  onSelectionChange: () => {},
  rowClassName: "bg-blue-100",
  stripe: true,
  hover: true,
};

export default CTSelectTable;
